import axios from "axios";

const client = axios.create({
  baseURL: import.meta.env.VITE_API_ENTRYPOINT,
  withCredentials: true,
  headers: { "Content-Type": "application/ld+json" },
});

export default client;
